import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Swipeable, LEFT } from 'react-swipeable';
import pluralize from 'pluralize';

import SrIcon from 'client/components/SrIcon';
import SrPropertyTypeLabel from 'client/components/SrPropertyTypeLabel';

class SrListingImageCard extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    photoCount: PropTypes.number.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    propertyType: PropTypes.string,
    hasSelfTour: PropTypes.bool,
    has3DTour: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  }

  _onSwipedPhoto = ({ dir }) => {
    if (dir === LEFT) {
      this.props.onClick();
    }
  }

  render() {
    const {
      imageUrl,
      photoCount,
      title,
      subtitle,
      propertyType,
      hasSelfTour,
      has3DTour,
      onClick,
    } = this.props;

    return (
      <div
        className='SrListingImageCard'
        onClick={onClick}
        style={imageUrl ? { backgroundImage: `url("${imageUrl}")` } : {}}
      >
        <Swipeable className='swipeableWrapper' onSwiped={this._onSwipedPhoto}>
          <span className='photoCount'>
            {pluralize('Photo', photoCount, true)}
          </span>
          <div className='caption'>
            <div className='icons'>
              {hasSelfTour && (
                <SrIcon className='label-self-tour-bolt-yellow' />
              )}
              {has3DTour && (
                <SrIcon className='label-3d-tour-orange' />
              )}
            </div>
            <span className='title'>{title}</span>
            <div className='bottom'>
              <span className='subtitle'>{subtitle}</span>
              {propertyType && (
                <SrPropertyTypeLabel propertyType={propertyType} />
              )}
            </div>
          </div>
        </Swipeable>
      </div>
    );
  }
}

SrListingImageCard.displayName = 'SrListingImageCard';

export default SrListingImageCard;
